import './OrganizationTreeName.css'
import OrganizationTreeGuides from './OrganizationTreeGuides'

const depthAccent = (level) => `var(--sb-org-depth-${Math.max(0, level) % 5})`

export default function OrganizationTreeName({ level, guides, editing = false, children }) {
  return (
    <span className={`org-tree-name${guides.hasParent ? ' has-parent' : ''}${editing ? ' is-editing' : ''}`} style={{ '--org-indent': `calc(${level} * var(--org-tree-indent-step))`, '--org-tree-line-accent': depthAccent(level - 1) }}>
      <OrganizationTreeGuides level={level} guides={guides} indentStep="var(--org-tree-indent-step)" />
      {editing ? (
        <span className="org-row-main">
          <span className="tree-toggle tree-toggle-spacer" aria-hidden="true" />
          {children}
        </span>
      ) : children}
    </span>
  )
}
